import {reduxForm} from 'redux-form';
import config from 'config';
import {push} from 'react-router-redux/lib/actions';
import {NEWS_ROUTER_ROOT} from '../constants';
import NewsEditForm from './NewsEditForm';
import newsCRUDAction from '../../../actions/news';
import {getCurrentClubId} from '../../../selectors/club-settings';
import {validateRedux, validateAsyncRedux} from '../../../utilites/validate';
import {NewsImageContent, NewsVideoContent, NewsLinkContent, NewsAWSContent} from '../../../api/news/news';

const INITIAL_VALUES = {typeContent: NewsImageContent};

const validate = (data) => {
  let validationRules = {
    title: {
      presence: true
    },
    content: {
      presenceContent: {message: '^Description is missing'}
    },
    image: {
      presence: {message: '^Please upload an image'}
    }
  };

  switch (data.typeContent) {
    case NewsLinkContent:
      Object.assign(validationRules, {
        link: {
          presence: {
            message: '^Please add a video link'
          },
          externalVideoLink: true
        }
      });
      break;
    case NewsAWSContent:
    case NewsVideoContent:
      Object.assign(validationRules, {
        video: {
          presence: {
            message: '^Please upload a video'
          },
          presenceVideo: true
        }
      });
      break;
  }
  return validateRedux(data, validationRules);
};

const asyncValidate = (data) => validateAsyncRedux(data, {
  image: {
    presence: {message: '^Please upload an image'},
    minImageSizeAsync: config.newsCrop
  }
});

export default reduxForm(
  {
    form: 'news_edit_form',
    fields: [
      'club_id',
      'title',
      'content',
      'typeContent',
      'video',
      'link',
      'image',
      'published'
    ],
    asyncBlurFields: ['image'],
    returnRejectedSubmitPromise: true,
    model: {},
    asyncValidate,
    validate
  },
  (state) => ({
    model: state.news.model,
    loading: state.news.loadingItem,
    isAbleToDelete: state.news.model && !state.news.model.isNew(),
    disabled: state.news.model && state.news.model.isPublished,
    initialValues: Object.assign(
      {},
      INITIAL_VALUES,
      {club_id: getCurrentClubId(state)},
      state.news.model ? state.news.model : {}
    )
  }),
  dispatch => ({
    save: async(item, data) => await dispatch(newsCRUDAction.save(item, data)),
    onCloseEditForm: async(item, data) => await dispatch(newsCRUDAction.onCloseEditForm(item, data)),
    publish: async(item) => await dispatch(newsCRUDAction.publish(item)),
    share: async(item) => await dispatch(newsCRUDAction.share(item)),
    goIndex: () => dispatch(push(NEWS_ROUTER_ROOT))
  })
)(NewsEditForm);



// WEBPACK FOOTER //
// ./src/components/News/NewsEditForm/index.js